import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import './PolicyAgrarianismToolbar.css'
import {CoinsStat} from "../../../PlayerStat/stats/CoinsStat";
import ModalButton from "../../../Modals/ModalWindow/ModalButton/ModalButton";
import {selectIsFarmAutoSelected, selectSelectedFarmHexKey} from "../../../../redux/reducers/privateStateReducer/selectors";
import {
  agrarianismCommitConversion,
  agrarianismSelectFarmForConversion,
  agrarianismSwitchConversionOff,
  agrarianismSwitchConversionOn,
  deselectFarm,
  showToast, withToastIcon
} from "../../../../redux/actions";
import {calcAgrarianismConversion} from "../../../../utils/policy/agrarianism/calcAgrarianismConversion";
import {SUPPLY_COLOR} from "../../../../styles/constants";
import PlayerStat from "../../../PlayerStat/PlayerStat";
import {REGISTRY_SINGLETON} from "../../../../scenes/Registry";
import {getCoinsActionText} from "../../../../utils/gameState/text/getCoinsText";
import {
  selectIsAgrarianismConversionOn,
  selectSelectedFarmsForConversion
} from "../../../../redux/reducers/sharedStateReducer/selectors";
import {
  selectIsParallelSupplyPhase,
  selectSupplyActingPlayer
} from "../../../../utils/gameState/supply/parallelSupplySelectors";
import {MASKED_ICON_TONES, MaskedIcon} from '../../../coloredIcons/MaskedIcon/MaskedIcon';
import {TOAST_ICONS} from "../../../../constants/toast";

const PolicyAgrarianismToolbar = () => {
  const dispatch = useDispatch();
  const selectedFarmHexKey = useSelector(selectSelectedFarmHexKey);
  const isFarmAutoSelected = useSelector(selectIsFarmAutoSelected);
  // Обмен — того игрока, за которого клиент раздает снабжение: в одновременной
  // фазе снабжения сетевой игры у каждого игрока свой выбор ферм (см.
  // selectSupplyActingPlayer), в поочередной — текущего игрока
  const supplyPlayer = useSelector(selectSupplyActingPlayer);
  const isParallelSupplyPhase = useSelector(selectIsParallelSupplyPhase);
  const isAgrarianismConversionOn = useSelector((state) => selectIsAgrarianismConversionOn(
    state, selectSupplyActingPlayer(state)?.id ?? null
  ));
  const selectedFarmsForConversion = useSelector((state) => selectSelectedFarmsForConversion(
    state, selectSupplyActingPlayer(state)?.id ?? null
  ));

  const {coins, usedSupplyCount} = calcAgrarianismConversion(selectedFarmsForConversion);

  // В одновременной фазе действия идут за своего игрока явно (без него —
  // игрок уже закончил фазу, менять нечего), в поочередной — без playerId, за
  // текущего игрока, как всегда
  const isActionAllowed = !isParallelSupplyPhase || Boolean(supplyPlayer);
  const actionPlayerId = isParallelSupplyPhase ? supplyPlayer?.id : undefined;

  const handleSwitchConversionOn = () => {
    if (!isActionAllowed) {
      return;
    }
    dispatch(agrarianismSwitchConversionOn(actionPlayerId))
    if (selectedFarmHexKey) {
      dispatch(deselectFarm())
      // Ферму, выделенную панелью, игрок на обмен не отдавал
      if (!isFarmAutoSelected) {
        dispatch(agrarianismSelectFarmForConversion(selectedFarmHexKey, actionPlayerId));
        REGISTRY_SINGLETON.getSoundManager().playDistributeSupply();
      }
    }
  }

  const handleSwitchConversionOff = () => {
    if (!isActionAllowed) {
      return;
    }
    dispatch(agrarianismSwitchConversionOff(actionPlayerId))
  }

  const handleConfirm = () => {
    if (!isActionAllowed) {
      return;
    }
    if (selectedFarmsForConversion.length < 2) {
      dispatch(showToast(`Нужно выбрать минимум 2 снабжения для обмена на монеты`, 'warning', 5000));
      return;
    }
    let coinsText = getCoinsActionText(coins);
    dispatch(withToastIcon(showToast(`Вы обменяли ${usedSupplyCount} снабжения на ${coins} ${coinsText}.`, 'success', 5000, true, true), TOAST_ICONS.COINS));
    dispatch(agrarianismCommitConversion(selectedFarmsForConversion, actionPlayerId));
    REGISTRY_SINGLETON.getSoundManager().playCoins(coins);
  }

  return (
    <div className={'agrarianism-toolbar'}>
      {isAgrarianismConversionOn ?
        <>
          <div className={'agrarianism-toolbar_conversion-stats'}>
            <PlayerStat
              text={selectedFarmsForConversion.length}
              noShrinkOnMobile={true}
              color={SUPPLY_COLOR}
              icon={'/img/icons/supply.png'}
              title={'Снабжение'}
            />
            <MaskedIcon
              className={'agrarianism-toolbar_icon from-to-icon'}
              src={'/img/icons/up.png'}
              alt={'Обменять'}
              title={'Обменять'}
              tone={MASKED_ICON_TONES.CONTROLS}
            />
            <CoinsStat
              text={coins}
              noShrinkOnMobile={true}
              isDarkColor={true}
              className={'agrarianism-toolbar_conversion-stats_coins'}
            />
          </div>
          <ModalButton
            onClick={handleConfirm}
            className={'agrarianism-toolbar_button'}
            noSound={true}
            style={{
              backgroundColor: SUPPLY_COLOR,
            }}
          >
            <h2>Подтвердить обмен</h2>
            <img
              className={'agrarianism-toolbar_icon'}
              src={'/img/icons/supply white.png'}
              alt={'Снабжение'}
              title={'Снабжение'}
            />
          </ModalButton>
          <ModalButton
            onClick={handleSwitchConversionOff}
            className={'agrarianism-toolbar_button'}
          >
            <h2>Сбросить выбор</h2>
            <img
              className={'agrarianism-toolbar_icon'}
              src={'/img/icons/supply white.png'}
              alt={'Снабжение'}
              title={'Снабжение'}
            />
          </ModalButton>
        </>
        : <ModalButton
          onClick={handleSwitchConversionOn}
          className={'agrarianism-toolbar_button'}
        >
          <h2>Обменять</h2>
          <img
            className={'agrarianism-toolbar_icon'}
            src={'/img/icons/supply outline.png'}
            alt={'Снабжение'}
            title={'Снабжение'}
          />
          <img
            className={'agrarianism-toolbar_icon from-to-icon'}
            src={'/img/icons/up white.png'}
            alt={'Обменять'}
            title={'Обменять'}
          />
          <img
            className={'agrarianism-toolbar_icon'}
            src={'/img/icons/coins outline.png'}
            alt={'Монеты'}
            title={'Монеты'}
          />
        </ModalButton>
      }
    </div>
  );
};

export default PolicyAgrarianismToolbar;
